export default "__VITE_ASSET__Bh8KgSht__"